import BaseFilterView from './base-filter-view';
//import template from '../../handlebars/client/posts-list-filtered.hbs';
class PostsListFilter extends BaseFilterView {
	constructor(options = {}) {
		super(options);
	}

	viewEvents() {
		return {
			'click .fake-event': 'handleFakeEventClick',
		};
	}

	postInitialize() {
		this.viewEvents = {};
	}

	bindings() {
		//_.bindAll(this, 'render', 'destroy');
	}

	// override as necessary for child-view-specific listeners
	childViewListeners() {
		return {};
	}

	setTemplate() {
		return import(/* webpackChunkName: "posts-list-filter" */ '../../handlebars/client/posts-list-filtered.hbs')
			.then((templateModule) => {
				this.template = templateModule.default;
			});
	}

	/**
	 * Overwrite if necessary, adding to postRenderView() should suffice for your needs.
	 * 
	postRender() {
		
	}
	*/

	/**
	 * View-specific post-render actions.  Define this.listTemplate and this.apiCall here for sure.
	 */
	postRenderView() {
		// the API call being made
		this.apiCall = 'posts';
		// the name of the template being rendered for items list
		//this.template = template;
		// destination for filtered lists
		this.$itemListDest = $('#posts-list-dest', this.$el);
	}

	/**
	 * Build the querystring used for updating the url.  This should be defined per view.
	 */
	buildQueryString() {
		var //expertise_filter = this.getSelectFilterValues('expertise'), // this.getSelectFilterValues('expertise'),
			//vision_filter = this.getCheckboxFilterValues('vision'),
			//programs_filter = this.getSelectFilterValues('programs'),
			//department_filter = this.getCheckboxFilterValues('depts'),
			//centers_filter = this.getCheckboxFilterValues('centers'),
			categories_filter = this.getSelectFilterValues('categories'),
			type_filter = this.getSelectFilterValues('type'),
			queryStringAr = [];
		/*
		if (expertise_filter.length) {
			queryStringAr.push('tag=' + expertise_filter);
		}
		if (vision_filter.length) {
			queryStringAr.push('vision=' + vision_filter);
		}
		if (programs_filter.length) {
			queryStringAr.push('programs=' + programs_filter);
		}
		if (department_filter.length) {
			queryStringAr.push('department=' + department_filter);
		}
		if (centers_filter.length) {
			queryStringAr.push('centers=' + centers_filter);
		}
		*/
		if (categories_filter.length) {
			queryStringAr.push('categories=' + categories_filter);
		}
		if (type_filter) {
			queryStringAr.push('type=' + type_filter);
			// type_filter defines the API call being made - 'posts' or 'events'
			//this.apiCall = type_filter;
		}

		if (queryStringAr.length) {
			return '?' + queryStringAr.join('&');
		}
		return '';
	}

	/**
	 * Build the Data Object for the API request.  This happens during handleUpdateQsFilters() and should be defined per view.
	 */
	getRequestData() {
		// update the API call being made
		this.apiCall = this.getQueryString('type') || 'posts';
		return {
			//expertise_news: this.getQueryString('tag'),
			//vision: this.getQueryString('vision'),
			//program_news: this.getQueryString('programs'),
			//depts: this.getQueryString('department'),
			//centers: this.getQueryString('centers'),
			categories: this.getQueryString('categories') || '',
			search: $('#filter-search', this.$el).length ? $('#filter-search', this.$el).val().toLowerCase().split(' ').join('+') : '',
			pnum: this.curPage,
			perpage: 12,
		};
	}

	/**
	 * Update display of filters. This happens during handleUpdateQsFilters() and should be defined per view.
	 */
	childUpdateFilters(tData) {
		// update checkboxes/selects here
		//this.setSelectFilterValues('expertise', tData.expertise_news);
		//this.setCheckboxFilterValues('vision', tData.vision);
		//this.setSelectFilterValues('programs', tData.program_news);
		//this.setCheckboxFilterValues('depts', tData.depts);
		//this.setCheckboxFilterValues('centers', tData.centers);
		this.setSelectFilterValues('categories', tData.categories);
	}

	childCleanup() {

	}


}

export default PostsListFilter;
